import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import moment from "moment";
import { Client_Search } from "../../Configuration/API_URL";
import { Dashboard_Client_Report } from "../../Configuration/API_URL";
import {
    AESEncryption,
    ApiResDecrypt,
    checkDateRange,
    compareDate,
    noDataFound,
} from "../../CommonMethhods/CommonMethods";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import { Constants } from "../../CommonMethhods/Constants";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useDebounce } from "../../Components/useDebounce";
import FnoDeliveryReportTable from "../../Components/ReportTables/FnoDeliveryReportTable";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function FnoDeliveryReport() {
    const storeToken = localStorage.getItem("ssoToken");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [clientList, setClientList] = useState([]);
    const [clientCode, setClientCode] = useState("");
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [data, setData] = useState("");
    const [errorResp, setErrorResp] = useState("");
    const [nameError, setNameError] = useState("");
    const [scrollLoader, setScrollLoader] = useState(false);
    const [count, setCount] = useState();
    const [offset, setOffset] = useState(0)
    const [dataCount, setDataCount] = useState()
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false)

    const calanderIcon = true
    const [errorGrid, setErrorGrid] = useState(false);
    const [page, setPage] = useState(1);
    const [show, setShow] = useState(false);
    const [mainError, setMainError] = useState(false);
    const [serverError, setServerError] = useState(false);
    const [fromDateError, setFromDateError] = useState(false)

    const debouncedValue = useDebounce(clientCode, 1000);
    useEffect(() => {
        handleClientName(debouncedValue);
    }, [debouncedValue]);

    // if (fromDate === "" || toDate === "") {
    //     const current = new Date();
    //     const CurrentYear = current.getFullYear();
    //     const CurrentMonth = current.getMonth();
    //     if (CurrentMonth < 4) {
    //         const newYear = `04-01-${CurrentYear - 1}`;
    //         const date = `${current.getMonth() + 1
    //             }-${current.getDate()}-${current.getFullYear()}`;
    //         const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //         setFromDate(newYear);
    //         setToDate(date1);
    //     } else {
    //         const newYear = `04-01-${CurrentYear}`;
    //         const date = `${current.getMonth() + 1
    //             }-${current.getDate()}-${current.getFullYear()}`;
    //         const date1 = moment(date, "MM-DD-YYYY").format("MM-DD-YYYY");
    //         setFromDate(newYear);
    //         setToDate(date1);
    //     }
    // }

    async function searchApiDetail(code, NoPage) {
        let payloadValue = {
            keyword: code,
            Status: "",
            PageNo: NoPage,
            PageSize: 10,
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getSearchDetail = await axiosInstance.post(
                Client_Search.Search_URL,

                `"${encPayload}"`,
            );

            const res = ApiResDecrypt(getSearchDetail?.data);
            if (res?.status === 0) {
                setCount(res?.data?.TotalCount);
                setNameError(false);
                if (page > 1) {
                    setClientList((prev) => {
                        return [...prev, ...res?.data?.clients];
                    });
                } else {
                    setClientList(res?.data?.clients);
                }
            } else {
                setNameError(res?.message);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoader(false);
            setMainError(false);
        }
    }

    function handleClientName(data) {
        if (data) {
            searchApiDetail(data, 1);
            setScrollLoader(true);
            setClientList([]);
            setPage(1);
        }
    }

    useEffect(() => {
        if (page > 1) {
            searchApiDetail(clientCode, page);
        }
    }, [page]);

    const getFnoDeliveryReport = async (fileView, offsetTab) => {
        if (fileView === "excel") {
            setSmallLoaderExcel(true);
        }
        if (fileView === "pdf") {
            setSmallLoaderPdf(true);
        }
        if (fileView === "grid" && offsetTab < 0) {
            setLoader(true);
        }
        let payloadValue = {
            partyCode: clientCode,
            fromDt: fromDate,
            toDt: toDate,
            offSet: offsetTab,
            limit: 10,
            fileType: fileView

        };
        console.log("payload value", payloadValue)
        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axiosInstance.post(
                Dashboard_Client_Report.FnoDeliveryReport_URL,
                `"${encPayload}"`,
            );
            const res = ApiResDecrypt(getDetails?.data);
            console.log("res", res)
            if (res?.status === 0) {
                if (fileView === "grid") {
                    setDataCount(res?.data?.TotalCount)
                    if (offsetTab > 0) {
                        setData((prev) => {
                            return [...prev, ...res?.data?.FNODeliveryList];
                        })
                    }
                    else {
                        setData(res?.data?.FNODeliveryList);
                    }
                    setScrollLoaderTable(false);

                } else if (fileView === "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileView === "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                } else {
                    toast.success("Mail sent successfully");
                }
            } else {
                setData([]);
                if (fileView !== "grid") {
                    toast.error(res?.message);
                } else {
                    setErrorGrid(res?.message);
                }
            }
        } catch (error) {
            console.log(error);
            setServerError(error?.message);
            if (fileView !== "grid") {
                toast.error(error?.message);
            }
        } finally {
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
        }
    };

    const handleFromDateChange = (e) => {
        if (e.target.value) {
            setErrorGrid(false);
            setData([]);
            setOffset(0)
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);
            setErrorResp(false);
            setFromDateError(false)
            setServerError(false);
            setMainError(false)
        }
        else {
            setFromDate("")
            setErrorGrid(false);
            setData([]);
            setErrorResp(false);
            setServerError(false);
            setFromDateError(false)
        }
    };
    const handleToDateChange = (e) => {
        if (e.target.value) {
            setErrorGrid(false);
            setOffset(0)
            setData([]);
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);
            setErrorResp(false);
            setServerError(false);
            setFromDateError(false)
            setMainError(false)
        }
        else {
            setToDate("")
            setErrorGrid(false);
            setData([]);
            setErrorResp(false);
            setServerError(false);
            setFromDateError(false)
        }
    };

    function formatDate(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    const handleOnClick = (e) => {
        setOffset(0)
        setShow(false);
        // if (clientCode) {
        if (e.target.value) {
            if (fromDate) {
                if (
                    (compareDate(fromDate) &&
                        compareDate(toDate) &&
                        checkDateRange(fromDate, toDate))
                ) {
                    getFnoDeliveryReport(e.target.value, 0);
                    setErrorResp(false);
                    setMainError(false)
                    setFromDateError(false)
                } else {
                    setErrorResp("Please Select To Date");

                }
            }
            else if (toDate) {
                if (
                    (compareDate(fromDate) &&
                        compareDate(toDate) &&
                        checkDateRange(fromDate, toDate))
                ) {
                    getFnoDeliveryReport(e.target.value, 0);
                    setErrorResp(false);
                    setMainError(false)
                } else {
                    setErrorResp(false);
                    setFromDateError("Please Select From Date ")

                }
            }
            else if (clientCode) {
                getFnoDeliveryReport(e.target.value, 0);
                setErrorResp(false);
                setMainError(false)
            }

            else {
                setMainError("Please Select Client Name/Code or From & To Date");
            }
        }
        else {
            setMainError("Please Select Client Name/Code or From & To Date");
        }
    };

    const handleScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
            if (!(count <= 10 * page)) {
                setPage((prev) => prev + 1);
                setScrollLoader(true);
            }
        }
    };

    const handleTableScroll = async (e) => {
        const a = e.target;
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoaderTable) {
            if (dataCount !== data?.length) {
                setLoader(false);
                setScrollLoaderTable(true);
                setOffset((prev) => prev + 1);
                let offsetTab = offset + 1
                getFnoDeliveryReport("grid", offsetTab)
            }
        }
    };
    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");


    return (
        <>
            <Header portal={"RM"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="reports interest-report-wrapper">
                <div className="card-box">
                    {/* <div>
            <h2 className="report-title">Cost Report</h2>
          </div> */}
                    <div className="row input-field-wrapper">
                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="row d-flex justify-content-between">
                                <div className="form-group">
                                    <label className="form-label">
                                        {Constants.Client_Code}
                                    </label>
                                    <div className="rm-custom-dropdown">
                                        <input
                                            type="text"
                                            name="search-text"
                                            className="input-st"
                                            placeholder="Search here..."
                                            autoComplete="off"
                                            value={clientCode}
                                            onChange={(e) => {
                                                setClientCode(e.target.value.toUpperCase());
                                                setShow(true);
                                                setErrorGrid(false);
                                            }}
                                            onInput={(e) => {
                                                const start = e.target.selectionStart;
                                                const end = e.target.selectionEnd;
                                                let input = e.target.value;
                                                input = input
                                                    .toUpperCase()
                                                    .replace(/[^A-Z0-9\s]/g, "")
                                                    .replace(/\s+/g, " ")
                                                    .trimStart()
                                                    .slice(0, 100);

                                                e.target.value = input;
                                                e.target.setSelectionRange(start, end);
                                            }}
                                        />
                                        <button
                                            className="rm-dropdown-btn"
                                            onClick={() => setShow(!show)}
                                        >
                                            <span className="icon-right-arrow-triangle"></span>
                                        </button>
                                        {show && (
                                            <>
                                                <ul
                                                    className="rm-mapping-ap border-0"
                                                    onScroll={(e) => handleScroll(e)}
                                                >
                                                    {clientList &&
                                                        clientList.map((item, i) => (
                                                            <li
                                                                key={i}
                                                                className="rm-maping-item-wrapper"
                                                                onClick={() => {
                                                                    setClientCode(item?.clientCode);
                                                                    setShow(false);
                                                                }}
                                                            >
                                                                <div> {item?.clientname}</div>
                                                                <div> {item?.clientCode}</div>
                                                            </li>
                                                        ))}
                                                    {scrollLoader && !loader && (
                                                        <div className="loader-center">
                                                            <LoaderForSearch />
                                                        </div>
                                                    )}
                                                    {nameError && !scrollLoader && (
                                                        <li
                                                            className="rm-maping-item-wrapper"
                                                            style={{
                                                                borderBottom: "none",
                                                                fontSize: "12px",
                                                            }}
                                                        >
                                                            {nameError}
                                                        </li>
                                                    )}
                                                </ul>
                                            </>
                                        )}
                                    </div>
                                    {mainError && (
                                        <span className="to-date-error">{mainError}</span>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="form-group calendar-icon">
                                <label className="form-label">Sauda From Date:</label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="datepicker form-control"
                                    id="FromDateCombine"
                                    onChange={handleFromDateChange}
                                    defaultValue={formatDate(fromDate)}
                                    max={DateReverse}
                                />
                                <span className="to-date-error">{fromDateError}</span>
                                {calanderIcon && <span className="icon-calendar ico"></span>}
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3 col-6">
                            <div className="form-group calendar-icon">
                                <label className="form-label">Sauda To Date:</label>
                                <input
                                    type="date"
                                    placeholder="DD/MM/YYYY"
                                    className="datepicker form-control"
                                    id="ToDateCombine"
                                    onChange={handleToDateChange}
                                    defaultValue={formatDate(toDate)}
                                    max={DateReverse}
                                />
                                <span className="to-date-error">{errorResp}</span>
                                {calanderIcon && <span className="icon-calendar ico"></span>}
                            </div>
                        </div>
                    </div>
                    <div className="text-center search-btn-wrapper">
                        <button
                            value="grid"
                            className="send-message"
                            onClick={handleOnClick}
                        >
                            {Constants.Search}
                        </button>
                    </div>

                    <div>
                        <ReportTableHeader
                            showEmailBtn={false}
                            smallLoaderExcel={smallLoaderExcel}
                            smallLoaderPdf={smallLoaderPdf}
                            handleOnClick={handleOnClick}
                        />
                    </div>
                    <div className="for-grid-section">
                        {loader ? (
                            <div className="loader-alignment">
                                <Loader />
                            </div>
                        ) : data && data.length > 0 ? (
                            <div>
                                <FnoDeliveryReportTable data={data} handleTableScroll={handleTableScroll} scrollLoaderTable={scrollLoaderTable} />
                            </div>
                        ) : serverError ? (
                            <h4 className="report-error-message">
                                {noDataFound(serverError)}
                            </h4>
                        ) : errorGrid ? (
                            noDataFound(errorGrid)
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </main>
        </>
    );
}

export default FnoDeliveryReport;
